/* app/js/src/components/channel/channels-dashboard/download-recording/download-recording.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.channel-code textarea::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.channel-code textarea::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.channel-code textarea::-webkit-scrollbar-corner {
  background: transparent;
}
.channel-code textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.channel-code textarea::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.channel-code textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.channel-code textarea::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.channel-code textarea::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.channel-code input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.channel-code input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.channel-code input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.channel-code input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.channel-code input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.channel-code input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.channel-code input.ng-invalid.ng-dirty,
.channel-code input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
button {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
button:focus {
  outline-color: #ffffff;
}
button:hover {
  background-color: white;
  color: #232f3a;
}
button.disabled {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.channel-code {
  padding: 20px 20px 5px 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #e1e6eb;
  position: relative;
}
.channel-code .buttons {
  text-align: right;
}
.channel-code header {
  font-size: 20px;
  line-height: 20px;
}
.channel-code section {
  margin-top: 20px;
}
.channel-code .field {
  margin-bottom: 10px;
}
.channel-code .label {
  color: #879baf;
  font-size: 12px;
}
.channel-code input {
  padding: 0 0 0 15px;
  margin: 0 5px;
}
.channel-code input[type=number]::-webkit-outer-spin-button,
.channel-code input::-webkit-inner-spin-button {
  position: relative;
  height: 20px;
  line-height: 30px;
}
.channel-code textarea {
  margin-top: 10px;
}
.channel-code textarea {
  border-radius: 4px;
  background-color: #ffffff;
  width: 318px;
  height: 45px;
  resize: none;
  font-size: 12px;
  line-height: 15px;
  padding: 5px 10px 0 10px;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
.channel-code textarea ::-webkit-input-placeholder {
  color: #c9cdd6;
}
.channel-code .close-sign {
  margin-left: 10px;
  cursor: pointer;
}
.triangle-with-shadow {
  width: 20px;
  height: 13px;
  position: absolute;
  overflow: hidden;
  right: 113px;
  top: -13px;
  background-color: transparent;
}
.triangle-with-shadow:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
  bottom: -13px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.response-message {
  color: red;
}
/*# sourceMappingURL=download-recording.component.css.map */
